module.exports = __webpack_public_path__ + "img/product5.88213b11.png";